<template>
  <v-container class="pa-0" style="max-height:100vh;"> 
    <v-row class="ma-0 pa-0" >
        <v-spacer/>
        <v-card-title class="px-0">Documentos</v-card-title>
        <v-spacer/>
    </v-row>
    <v-row class="ma-0 pa-0" style="position:absolute!important; top:13px;">
        <v-btn class="mr-2 pt-7" to='/' icon><v-icon>mdi-chevron-left</v-icon></v-btn>
    </v-row>
    <div v-if="documents.length>0">
        <v-card v-for="(document, index) in documents" :key="index" class="mb-4 elevation-0 py-3 px-4" target="_blank" :href="'https://peach.blitzhub.mx/files/' + document.url">
            <v-row class="ma-0">
                <v-icon class="mr-4">mdi-download</v-icon>
                <div>
                    <v-card-title style="font-size:18px;" class="ma-0 pa-0">{{document.title}}</v-card-title>
                    <v-card-subtitle style="font-size:12px; color:grey; font-weight:600;" class="ma-0 pa-0">{{document.description}}</v-card-subtitle>
                </div>
            </v-row>
        </v-card>
    </div>
    <div v-else style="text-align:center; filter:opacity(.5);" class="mt-12 pt-12">
        No hay documentos aún
        <br/>
        <br/>
        <span style="font-size:100px;">{{':('}}</span>
    </div>
    
  </v-container>
</template>

<script>
import axios from "axios"
export default {
    data(){
        return{
            loader:true,
            documents:[],
        }
    },
    created(){
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer_files').then(response=>{
            this.documents = response.data.data
            this.loader = false
        })
    }
}
</script>

<style>

</style>